export default {
  title: "Редактировать профиль",
  form: {
    avatar_image_url: {
      label: "Аватар",
      btn_modal_open: "Обновить изображение аватара",
      modal: {
        label_btn: 'Изображение профиля',
        btn_modal_open: 'Изменить изображение профиля',

        modal_title: 'Изменение изображения профиля',
        modal_description: 'Загрузите изображение или сгенерируйте новое.',

        file_title: 'Загрузить',
        file_label: 'Выберите файл для загрузки',
        file_description: 'Допустимый формат: *.jpg, *.png. Максимальный размер 4Mb.',

        generate_title: 'Сгенерировать',
        btn_generate: 'Сгенерировать случайное изображение',

        widget_otp_name: 'Обновление изображения профиля пользователя',

        submit: 'Сохранить изменения',
        saving_changes: 'Сохранение изменений...',
      },
    },
    name: {
      label: "Имя",
    },
    first_name: {
      label: "Имя",
      placeholder: "Введите имя",
    },
    last_name: {
      label: "Фамилия",
      placeholder: "Введите фамилию",
    },
    timezone: {
      label: "Часовой пояс",
      placeholder: "Введите город",
    },
    button: {
      close: "Закрыть",
      save: "Сохранить",
    },
  },
}
